import { Canvas } from "@react-three/fiber";
import Ring from "./ring";
import { useState, useEffect } from "react";

export default function Scene() {
  const [radius, setRadius] = useState(2);

  useEffect(() => {
    const handleResize = () => {
      setRadius(window.innerWidth <= 768 ? 1.5 : 2);
    };

    handleResize(); // Set initial size
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Canvas className="bg-black">
      <Ring
        text="D E C O D E T E C H N O L O G Y "
        radius={radius}
        height={4}
        segments={32}
      />
    </Canvas>
  );
}
